export type RefreshOutcome =
  | { kind: 'success'; accessToken: string }
  | { kind: 'rejected' }
  | { kind: 'unreachable' };

type RefreshFn = () => Promise<RefreshOutcome>;

const inFlight = new Map<string, Promise<RefreshOutcome>>();

/**
 * Coalesces concurrent refresh calls for a given key into a single network call.
 * All callers await the same promise; it's cleared once settled.
 */
export function singleFlightRefresh(
  key: string,
  fn: RefreshFn,
): Promise<RefreshOutcome> {
  const existing = inFlight.get(key);
  if (existing) return existing;

  const p = fn().finally(() => {
    inFlight.delete(key);
  });
  inFlight.set(key, p);
  return p;
}
